import { Button, Badge, Spinner, Alert } from '../../components/ui';
import { claveDia, esFutura } from '../../utils/fechas';
import ListaFechas from './ListaFechas';
import './Buscar.css';

function agruparPorDia(turnos) {
  const mapa = new Map();
  (turnos || [])
    .filter((t) => esFutura(t.fechaYHora))
    .forEach((t) => {
      const k = claveDia(t.fechaYHora);
      if (!mapa.has(k)) mapa.set(k, { clave: k, fecha: t.fechaYHora, cantidad: 0 });
      mapa.get(k).cantidad += 1;
    });
  return [...mapa.values()].sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
}

export default function PasoFecha({ turnos, criterioLabel, cargando, error, onElegir, onVolver }) {
  const fechas = agruparPorDia(turnos);

  return (
    <section aria-labelledby="t1">
      <div className="buscar-turno-row" style={{ alignItems: 'baseline' }}>
        <h2 id="t1" style={{ margin: 0 }}>Elegí una fecha</h2>
        {criterioLabel && <Badge tone="info">{criterioLabel}</Badge>}
      </div>
      <p className="buscar-muted">Fechas futuras con turnos disponibles, ordenadas cronológicamente.</p>

      {cargando && <Spinner label="Buscando fechas disponibles…" />}
      {error && <Alert tone="danger" title="No pudimos buscar turnos">{error}</Alert>}

      {!cargando && !error && <ListaFechas fechas={fechas} onElegir={onElegir} />}

      <div className="buscar-actions">
        <Button variant="secondary" onClick={onVolver}>← Volver</Button>
      </div>
    </section>
  );
}